export default __webpack_public_path__ + "media/oxytocinSeo.95364bcaee49e82711e227389ff956dd.webp";